/**
 * Temporal GraphQL operations (Temporal Mode).
 *
 * `brandChangeActivity` feeds the Time-travel panel's change-density strip:
 * monthly {revisions, uploads, moves} counts from brand epoch to now, plus
 * `historySince` (the picker's min bound). Brand context is ambient (global
 * state on the server) — the query takes no variables.
 * SDL pinned in BrandServer.GraphQL.Tests/Types/TemporalSchemaTests.cs.
 */

// ============================================================================
// Queries
// ============================================================================

export const TEMPORAL_QUERIES = {
    GET_BRAND_CHANGE_ACTIVITY: `
        query GetBrandChangeActivity {
            brandChangeActivity {
                historySince
                months {
                    year
                    month
                    revisions
                    uploads
                    moves
                }
            }
        }
    `,
};

// ============================================================================
// Types
// ============================================================================

/** One calendar month of content-change counts (gap months arrive zero-filled). */
export interface BrandChangeActivityMonth {
    year: number;
    month: number;
    revisions: number;
    uploads: number;
    moves: number;
}

export interface BrandChangeActivityResult {
    /** Brand epoch — the earliest instant history can reach (picker min bound). */
    historySince: string;
    /** Continuous months from epoch to now (server zero-fills gaps). */
    months: BrandChangeActivityMonth[];
}

// ============================================================================
// Response Types
// ============================================================================

export interface GetBrandChangeActivityResponse {
    brandChangeActivity: BrandChangeActivityResult;
}
